import { Box, Typography } from '@mui/material';

import { EthicsPill } from '@/components';
import { ComplianceTypes } from '@/constants';
import { selectEpisodeCompliance, useAppSelector } from '@/store';
import { Episode } from '@/types';
import { getIsEpisodeEthics } from '@/utils';

export const EpisodeHeader = ({ episode }: { episode: Episode }) => {
  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episode?.episodeId),
  );

  const isEpisodeEthics = getIsEpisodeEthics({ episode, compliance });

  const hideDetails =
    !isEpisodeEthics ||
    episode.isArchived ||
    (compliance === ComplianceTypes.CPE &&
      episode.compliance !== ComplianceTypes.CPE);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="hero2">{episode.name}</Typography>
      <Typography variant="body2">{episode.hook}</Typography>
      {!hideDetails && (
        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            alignItems: 'center',
          }}>
          <EthicsPill
            compliance={compliance}
            ethicsDuration={episode.totalEthics}
          />
        </Box>
      )}
    </Box>
  );
};
